// Bound the DOM for wide worksheets while retaining the full sheet geometry.
export function databookColumnWindow(
  offsets: readonly number[],
  widths: readonly number[],
  scrollLeft: number,
  viewportWidth: number,
): { start: number; end: number } {
  if (widths.length <= 80) return { start: 0, end: widths.length - 1 };
  const left = Math.max(0, scrollLeft - 400);
  const right = scrollLeft + viewportWidth + 400;
  let start = 0;
  while (start < widths.length - 1 && offsets[start] + widths[start] < left) start += 1;
  let end = start;
  while (end < widths.length - 1 && offsets[end + 1] < right) end += 1;
  return { start, end };
}
